import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";

export const usePermission = () => {
  const { data: user } = useSelector((state: RootState) => state.user);

  const hasPermission = useCallback(
    (module: string, action?: string) => {
      // Super Admin bypass (admin role with no specific roleId)
      const isSuperAdmin =
        (user?.role?.toLowerCase() === "admin" ||
          user?.infos?.role?.toLowerCase() === "admin") &&
        !user?.roleId;

      if (isSuperAdmin) return true;

      const permissions = user?.permissions || [];

      if (!action) {
        // Check if user has ANY access to this module
        return permissions.some(
          (p: string) =>
            p.toLowerCase() === module.toLowerCase() ||
            p.toLowerCase().startsWith(`${module.toLowerCase()}.`),
        );
      }

      // Check for specific permission (e.g., "deliveryman.Delete")
      const target = `${module}.${action}`.toLowerCase();
      return permissions.some((p: string) => p.toLowerCase() === target);
    },
    [user],
  );

  return { hasPermission };
};

export default usePermission;
